import apiClient from "../helpers/apiClient";
import { handleApiError } from "../utils/handleApiError";

export async function createIntent(data:any) {
    try {
        const response = await apiClient.post(`/experiences/bookings/create-intent/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }    
}

export async function preValidateBooking(params:any) {
    try {
        const response = await apiClient.get(`/experiences/bookings/validate/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getUserRelatives() {
    try {
        const response = await apiClient.get(`/users/relatives/`);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getHostBookingRequests(params: any = {}) {
    try {
        const response = await apiClient.get(`/experiences/bookings/requests/`, { params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function acceptBookingRequest(id: number) {
    try {
        const response = await apiClient.post(`/experiences/bookings/${id}/accept/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function rejectBookingRequest(id: number) {
    try {
        const response = await apiClient.post(`/experiences/bookings/${id}/reject/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

